// extracted by mini-css-extract-plugin
module.exports = {"headerText":"index_headerText_feZX-","user":"index_user_6wFhA"};